export default __webpack_public_path__ + "static/media/blogImg2.d462b99c.png";